import { render, staticRenderFns } from "./_Products.vue?vue&type=template&id=240cd228"
import script from "./_Products.vue?vue&type=script&lang=js"
export * from "./_Products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports